var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "selectProjectModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.select_project"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.cancel")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$emit("selection", _vm.$refs.table.getSelections())
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.select")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "div",
        {
          staticClass: "bs-table-custom-toolbar",
          attrs: { id: "projectsToolbar" },
        },
        [
          _c(
            "c-switch",
            _vm._b(
              {
                staticStyle: {
                  "margin-left": "1rem",
                  "margin-right": "0.5rem",
                },
                attrs: {
                  id: "showInactiveProjects",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.showInactiveProjects,
                  callback: function ($$v) {
                    _vm.showInactiveProjects = $$v
                  },
                  expression: "showInactiveProjects",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.$t("message.show_inactive_projects"))),
          ]),
        ],
        1
      ),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }